// extracted by mini-css-extract-plugin
export var equalColumn = "_f0-0";